<template>
  <div class="upload-file-page">
    <el-container>
      <el-header>
       <el-steps class="steps" :active="0">
          <el-step title="上传" class="icon-11"></el-step>
          <el-step title="编辑" class="icon-33"></el-step>
        </el-steps>
      </el-header>
      <el-main>
        <upload
          :userInfo="userInfo"
          @startUpload="startUpload"
          @pauseUpload="pauseUpload"
          @complated="complatedHandler"
        />
      </el-main>
      <el-footer class="footer">
        <el-button v-if="nextStep" type="primary" @click="nextStepFn">下一步</el-button>
        <!--<el-button v-if="nextStep" type="primary" @click="nextStepFn">提交</el-button>-->
      </el-footer>
    </el-container>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import upload from '@/components/sdkUploadFile'
import { fetchMaterial } from '@/resource/api'
export default {
  name: 'uploadPage',
  components: {
    upload
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'userType'
    ])
  },
  data () {
    return {
      fileList: null,
      nextStep: false,
      startState: false,
      programId: ''
    }
  },
  mounted () {
    const that = this
    window.addEventListener('beforeunload', function (event) {
      if (that.startState) {
        window.event.returnValue = false
      }
    })
  },
  methods: {
    startUpload () {
      this.startState = true
    },
    pauseUpload () {
      this.startState = false
    },
    complatedHandler (fileList) {
      this.fileList = fileList
      if (fileList.length > 0) {
        this.nextStep = true
      } else {
        this.nextStep = false
      }
      this.startState = false
    },
    nextStepFn () {
      console.log(this.fileList, 'this.fileList')
      if (!this.fileList[0].md5) {
        this.$message.error('请先上传文件')
      } else {
        this.fetchMaterial()
      }
    },
    fetchMaterial () {
      const fileList = this.fileList[0]
      const data = {
        md5: fileList.md5,
        path: fileList.path,
        type: 'SDK',
        createBy: this.$store.getters.userInfo.username
      }
      fetchMaterial(data).then((res) => {
        if (res.code == '1') {
          this.nextStep = false
          this.programId = res.result.id
          this.$router.push({
            path: '/newGroup',
            query: {
              dialogData: JSON.stringify({
                title: '新增编目',
                programId: this.programId,
                uploadPage: 'true'
              })
            }
          })
        }
      })
    },
    leavePage (cb) {
      this.$confirm('当前文件正在上传中，是否离开?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        cb && cb()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.startState) {
      this.leavePage(() => {
        next()
      })
    } else {
      next()
    }
  }
}
</script>
<style lang="less">
  .upload-file-page {
    margin: 0 auto;
    .steps {
      width: 50%;
      margin: 0 auto 26px;
    }
    .el-upload-dragger {
      width: 900px;
      height: 224px;
      .el-icon-upload {
        margin-top: 26px;
      }
    }
    .footer {
      text-align: center;
      padding-top: 20px;
    }
     .el-step__main {
      display: inline-block;
      padding-right: 4px;
      position: absolute;
      top: -6px;
      left: 22px;
      white-space: nowrap;
      background: #fff;
    }
    .el-step__title {
      font-size: 13px;
      padding-left: 10px;
      font-weight: normal;
    }
    .el-step__head.is-process,.el-step__title.is-process {
      color: #7F63F2;
      border: #7F63F2;
    }
    .icon-11 .el-step__icon.is-text{
      background: #7F63F2;
      color: #fff;
      border:#7F63F2;
    }
   .icon-22 .el-step__icon.is-text {
      color: #979797;
      border-color: #979797;
    }
    .el-step__icon-inner[class*=el-icon]:not(.is-status) {
      font-size: 20px;
    }
  }
</style>
